import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PushmsgService {
	url = environment.serverAPI4+ "/pushnotifications";
  headers:any;


  constructor(private http: HttpClient) {
  }


  tokenidSend(fcmToken:any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, fcmToken);
  }



}
